import { Navigate, useLocation } from 'react-router-dom';
import { PrivateRouteI } from 'src/models/router';
import { RoutePath } from 'src/router/routePath';
import { isLogged } from 'src/services/auth';
import { OPTION_TOOLS_ENABLED } from 'src/config/features';

export const PrivateRoute = ({ children }: PrivateRouteI) => {
  const location = useLocation();

  return isLogged ? (
    children
  ) : !OPTION_TOOLS_ENABLED ? (
    <Navigate to={RoutePath.LOGIN} replace />
  ) : (
    <Navigate
      to={{
        pathname: RoutePath.LOGIN,
        search: `?return_to=${encodeURIComponent(
          `${location.pathname}${location.search}`,
        )}`,
      }}
      replace
    />
  );
};
